._ApplicationsView_5dfg7_1 {
  /* Empty file & class, used as a placeholder for future styling */
}